// src/layouts/PublicLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/common/Navbar/Navbar';

const PublicLayout = () => {
  return (
    <div>
      <Navbar/>
      <Outlet /> {/* Renders the child routes like Login, Signup */}
    </div>
  );
};

export default PublicLayout;
